import api from '@/lib/api';

/* Testimonials (Coach-Cockpit W1.7): dieselben Karten im CRM (CRM-Anmeldung, /api/…) und auf /coach (Trainer-Sitzung,
   eigener axios-Client mit baseURL /api/coach). Bilder kommen nur als Blob mit Anmeldung — nie als offene URL. */

const blob = (klein) => ({ params: klein ? { klein: 1 } : {}, responseType: 'blob', timeout: 30000 });

export const testimonialCrm = (leadId) => ({
  stand: () => api.get(`/testimonials/mitglied/${leadId}`),
  einwilligen: (umfang, version, weg = 'crm') => api.post('/einwilligungen', { lead_id: leadId, art: 'testimonial', umfang, version, weg }),
  widerrufen: (einwilligungId) => api.post(`/einwilligungen/${einwilligungId}/widerruf`),
  vorschlag: (art, id) => api.get(`/testimonials/mitglied/${leadId}/vorschlag`, { params: { art, id } }),
  anlegen: (daten) => api.post('/testimonials', { ...daten, lead_id: leadId }),
  aendern: (tid, daten) => api.patch(`/testimonials/${tid}`, daten),
  zuschnitt: (tid, daten) => api.post(`/testimonials/${tid}/zuschnitt`, daten),
  mediumWeg: (tid, mid) => api.delete(`/testimonials/${tid}/medien/${mid}`),
  medium: (tid, mid, klein) => api.get(`/testimonials/${tid}/medien/${mid}`, blob(klein)),
  vorlage: (fid, klein) => api.get(`/testimonials/mitglied/${leadId}/foto/${fid}`, blob(klein)),
  freigeben: (tid) => api.post(`/testimonials/${tid}/freigeben`),
  zurueckziehen: (tid, grund) => api.post(`/testimonials/${tid}/zurueckziehen`, { grund }),
});

export const testimonialCoach = (coach, mid) => ({
  stand: () => coach.get(`/testimonials/mitglied/${mid}`),
  einwilligen: (umfang, version) => coach.post(`/testimonials/mitglied/${mid}/einwilligung`, { umfang, version }),
  widerrufen: () => coach.post(`/testimonials/mitglied/${mid}/einwilligung/widerruf`),
  vorschlag: (art, id) => coach.get(`/testimonials/mitglied/${mid}/vorschlag`, { params: { art, id } }),
  anlegen: (daten) => coach.post(`/testimonials/mitglied/${mid}`, daten),
  aendern: (tid, daten) => coach.patch(`/testimonials/${tid}`, daten),
  zuschnitt: (tid, daten) => coach.post(`/testimonials/${tid}/zuschnitt`, daten),
  mediumWeg: (tid, m) => coach.delete(`/testimonials/${tid}/medien/${m}`),
  medium: (tid, m, klein) => coach.get(`/testimonials/${tid}/medien/${m}`, blob(klein)),
  vorlage: (fid, klein) => coach.get(`/testimonials/mitglied/${mid}/foto/${fid}`, blob(klein)),
  freigeben: (tid) => coach.post(`/testimonials/${tid}/freigeben`),
  zurueckziehen: (tid, grund) => coach.post(`/testimonials/${tid}/zurueckziehen`, { grund }),
});

export const bibliothekCrm = {
  liste: () => api.get('/testimonials/bibliothek'),
  bild: (mid, klein) => api.get(`/testimonials/bibliothek/medien/${mid}`, blob(klein)),
  contentplan: (tid, marke) => api.post(`/testimonials/${tid}/contentplan`, { marke }),
  schalter: () => api.get('/testimonials/schalter'),
  schalten: (daten) => api.put('/testimonials/schalter', daten),
};

export const bibliothekCoach = (coach, master) => ({
  liste: () => coach.get('/testimonials/bibliothek'),
  bild: (mid, klein) => coach.get(`/testimonials/bibliothek/medien/${mid}`, blob(klein)),
  contentplan: master ? (tid, marke) => coach.post(`/testimonials/${tid}/contentplan`, { marke }) : null,
});

/* „−4,2 kg Gewicht · −6 cm Taille in 4 Wochen“ — dieselbe Schreibweise wie der Server (testimonials/kern.ergebnis_text) */
export const zahlText = (z) => {
  const w = Number(z.wert);
  const vz = w < 0 ? '−' : w > 0 ? '+' : '±';
  const zahl = Math.abs(w).toFixed(1).replace(/\.0$/, '').replace('.', ',');
  return `${vz}${zahl}${z.einheit ? ` ${z.einheit}` : ''} ${z.label}`;
};
export const ergebnisText = (zahlen, zeitraum) => (zahlen || []).map(zahlText).join(' · ') + (zeitraum && zahlen?.length ? ` in ${zeitraum}` : '');

export const fehlerText = (e, rest) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : rest);
